'use client';

import React, { useState } from 'react';
import EmailModal from './EmailModal';

type DownloadButtonProps = {
  variant: 'primary' | 'secondary';
  source: 'vscode' | 'cursor';
  className?: string;
  children: React.ReactNode;
};

export default function DownloadButton({ variant, source, className = '', children }: DownloadButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  
  return (
    <>
      <button 
        onClick={openModal}
        className={`btn-${variant} ${className}`}
      >
        {children}
      </button>
      
      <EmailModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        source={source} 
      />
    </>
  );
} 